import React from "react";

interface MenuBookIconProps {
  size?: number;
  color?: string;
}

export default function MenuBookIcon({ size = 16, color = "#666" }: MenuBookIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 2v12c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V2H2z"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M8 2v13"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M5 5h1M10 5h1M5 7h1M10 7h1M5 9h1M10 9h1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}